// extracted by mini-css-extract-plugin
export var dot = "_rj-2";
export var wave = "_rj-0";
export var waveSmall = "_rj-1";